export default "__VITE_ASSET__ykdQnVHs__"